import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";

import { env } from "../../config/env";
export class MissionsAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/mission`;
	}

	/** Copy the planned lat/lon to the pulled lat/lon for the specified core */
	public async fudgeCore(jobId: string, coreId: string): Promise<void> {
		await this.fudgeCores(jobId, [coreId]);
	}

	/** Copy the planned lat/lon to the pulled lat/lon for the specified cores */
	public async fudgeCores(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/fudge`;
		await apiClient.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}

	/** Delete the specified core from the mission */
	public async deleteCore(jobId: string, coreId: string): Promise<void> {
		await this.deleteCores(jobId, [coreId]);
	}

	/** Delete the specified cores from the mission */
	public async deleteCores(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/delete`;
		await apiClient.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}

	/** Set core length of specified cores to the average of the other cores */
	public async setAverageCoreLength(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/set-average-length`;
		await apiClient.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}
}
